import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { ICreateUndoRequest, IProtocolEF, IRichiestaAnnullamento } from "../shared/interfaces";

const controller = 'RichiesteAnnullamento';

const addUndoRequest = (aooId: number, uorId: number, protocolSPId: number, createUndoRequest: ICreateUndoRequest, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/AddUndoRequest/${protocolSPId}`, createUndoRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const approveUndoRequest = (aooId: number, uorId: number, protocolSPId: number, undoProtocolRequestId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/ApproveUndoRequest/${protocolSPId}`, undoProtocolRequestId, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const rejectUndoRequest = (aooId: number, uorId: number, protocolSPId: number, undoProtocolRequestId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/RejectUndoRequest/${protocolSPId}`, undoProtocolRequestId, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const checkRichiestaAnnullamentoInCorso = (aooId: number, uorId: number, protocolEFId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/CheckRichiestaAnnullamentoInCorso/${protocolEFId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    addUndoRequest,
    approveUndoRequest,
    rejectUndoRequest,
    checkRichiestaAnnullamentoInCorso
}
